import $ from 'jquery';
export default function project() {
    $('#question-project .accordion').click("click", function() {
        if($(this).hasClass('current') == false) {
            $(this).addClass('current');
        } else {
            $(this).removeClass('current');
        }
        $('#question-project .question-active').not('current').next('.panel').removeClass('question-show');
        $('#question-project .question-active').not('current').removeClass('question-active current');
        if($(this).hasClass('current') == true) {
            if($(this).hasClass('question-active') == false) {
                $('#question-project .accordion.current').addClass('question-active');
                $('#question-project .accordion.current + .panel').addClass('question-show');
            }
        }

    });

}